export default __webpack_public_path__ + "static/media/18_tag_paid-massage-service.a400dfc6.svg";